import React, { Component } from 'react'
import { NavLink } from 'react-router-dom'
import adminRoutes from '../../routes/adminRoutes'
import routes from '../../routes/routes'
import Icon from '../Icon'

type MenuItemName = 'subscribers' | 'sites' | 'users' | 'trials' | 'metas' | 'logout'

type MenuItemsData = Record<MenuItemName, MenuItemData>

interface MenuItemData {
  text: string
  to: string
  icon: string
}

interface MenuItemProps {
  name: MenuItemName
  onRoute: () => void
}

export default class MenuItem extends Component<MenuItemProps> {
  items: MenuItemsData = {
    subscribers: { text: 'Subscribers', to: adminRoutes.subscribers, icon: 'group' },
    sites: { text: 'Sites', to: adminRoutes.sites, icon: 'map-pin-4' },
    users: { text: 'Users', to: adminRoutes.users, icon: 'user-location' },
    trials: { text: 'Trials', to: adminRoutes.trials, icon: 'chat-forward' },
    metas: { text: 'Metas', to: adminRoutes.metas, icon: 'git-merge' },
    logout: { text: 'Logout', to: routes.logout, icon: 'logout-box-r' }
  }

  get item () {
    return this.items[this.props.name]
  }

  render () {
    return (
      <NavLink
        exact={true}
        className="inline-block text-white w-full px-4 py-3"
        to={this.item.to}
        activeClassName="bg-tertiary text-primary"
        onClick={this.props.onRoute}>
        <div className="flex items-center">
          <Icon
            name={this.item.icon}
            size="medium"
            color="inherit" />
          <p className="ml-2">
            {this.item.text}
          </p>
        </div>
      </NavLink>
    )
  }
}
